(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[78],{

/***/ 44431:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...args]",
      function () {
        return __webpack_require__(68790);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 68790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ DynamicPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_pagebuilder_pageBuilder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96888);
/* harmony import */ var _components_ui_divider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98121);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2962);




var __N_SSG = true;
function DynamicPage(props) {
    var cmsPage = props.cmsPage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .DefaultSeo */ .lX, {
                title: (cmsPage === null || cmsPage === void 0 ? void 0 : cmsPage.meta_title) || (cmsPage === null || cmsPage === void 0 ? void 0 : cmsPage.title) || undefined,
                description: (cmsPage === null || cmsPage === void 0 ? void 0 : cmsPage.meta_description) || undefined
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_divider__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                className: "mb-0 pt-0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pagebuilder_pageBuilder__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                pagebuilder: cmsPage === null || cmsPage === void 0 ? void 0 : cmsPage.pagebuilder
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [928,888,179], function() { return __webpack_exec__(44431); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);